import { Component } from '@angular/core';

@Component({
  selector: 'app-configuracion-asistencia',
  templateUrl: './configuracion-asistencia.component.html',
  styleUrls: ['./configuracion-asistencia.component.css'],
  standalone: true,
  imports: [

  ],
})
export class ConfiguracionAsistencia {

}
